import React from "react"

import { Badge } from "@coval/ui/badge"
import { Tooltip } from "@coval/ui/tooltip"

import type { Message } from "@/types/Transcript"

import {
  getResponseLatencySeverity,
  type ResponseLatencySeverity,
} from "./responseLatency"
import { TimestampDisplay } from "./TimestampDisplay"

const BADGE_VARIANT_BY_SEVERITY = {
  normal: "default",
  slow: "warning",
  "very-slow": "danger",
} as const satisfies Record<ResponseLatencySeverity, string>

interface MessageTimingProps {
  message: Message
  /** The silence before this message, when an open latency metric measured one. */
  latencySeconds?: number
}

/**
 * The line under a bubble that says when the message ran and, when a latency
 * metric is open, how long the speaker took to start it.
 */
export const MessageTiming: React.FC<MessageTimingProps> = ({
  message,
  latencySeconds,
}) => {
  if (latencySeconds == null) {
    return <TimestampDisplay message={message} className="text-right" />
  }

  return (
    <div className="flex items-end justify-between gap-2">
      <Tooltip content="Response latency: the silence before this message">
        <Badge
          variant={
            BADGE_VARIANT_BY_SEVERITY[
              getResponseLatencySeverity(latencySeconds)
            ]
          }
          className="mt-1.5 h-5 px-1.5 font-mono text-xs"
        >
          {latencySeconds.toFixed(2)} s
        </Badge>
      </Tooltip>
      <TimestampDisplay message={message} className="text-right" />
    </div>
  )
}
